import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { defaultContent, mergeContent } from "@/lib/siteContent";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(defaultContent);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/content")
      .then((res) => setContent(mergeContent(defaultContent, res.data)))
      .catch(() => setContent(defaultContent))
      .finally(() => setLoaded(true));
  }, []);

  return (
    <ContentContext.Provider value={{ content, setContent, loaded }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
